// extracted by mini-css-extract-plugin
module.exports = {"select":"UserAnalytics--select--3dwCd","left":"UserAnalytics--left--2cNpp","right":"UserAnalytics--right--2BQyG","cancel_button":"UserAnalytics--cancel_button--2-C7L"};